<div class="modal-header border">
  <h4 class="modal-title text-primary">Notes</h4>
  <button type="button"
          class="btn-close"
          aria-label="Close"
          (click)="activeModal.dismiss('Cross click')"></button>
</div>
<div class="modal-body">
  <div>
    <era-notes-list [notes]="currentUdid()"
                    (noteUpdated)="noteAdded($event)"
                    (noteRemoved)="noteDeleted($event)"></era-notes-list>
  </div>
</div>